/**
 * @generated SignedSource<<e65d28392fdaccd5179bff2375058d6d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type viewAgent_AtlassianConversationAssistantAgent_ViewAgentModalInternal_agentRef$data = {
  readonly agentSchemaNumber: number | null;
  readonly instructions?: string | null;
  readonly jiraAssignability?: {
    readonly isAssignable: boolean | null;
  } | null;
  readonly permissions?: {
    readonly canEdit: boolean;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"agentVerificationDropdownItem_AtlaskitRovoAgentComponents_agentRef" | "agentVerified_AtlaskitRovoAgentComponents" | "creator_AtlassianConversationAssistantAgent_AgentCreatorDataComponent">;
  readonly " $fragmentType": "viewAgent_AtlassianConversationAssistantAgent_ViewAgentModalInternal_agentRef";
};
export type viewAgent_AtlassianConversationAssistantAgent_ViewAgentModalInternal_agentRef$key = {
  readonly " $data"?: viewAgent_AtlassianConversationAssistantAgent_ViewAgentModalInternal_agentRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"viewAgent_AtlassianConversationAssistantAgent_ViewAgentModalInternal_agentRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "enableJiraAgentFields"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "enableStudioGSNAndScenarioRefresh"
    }
  ],
  "kind": "Fragment",
  "name": "viewAgent_AtlassianConversationAssistantAgent_ViewAgentModalInternal_agentRef",
  "selections": [
    {
      "condition": "enableJiraAgentFields",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "concreteType": "AgentStudioAgentPermissions",
          "kind": "LinkedField",
          "name": "permissions",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "canEdit"
            }
          ]
        },
        {
          "args": [
            {
              "kind": "Variable",
              "name": "cloudId",
              "variableName": "cloudId"
            }
          ],
          "concreteType": "JiraAgentAssignability",
          "kind": "LinkedField",
          "name": "jiraAssignability",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "isAssignable"
            }
          ]
        }
      ]
    },
    {
      "condition": "enableStudioGSNAndScenarioRefresh",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "instructions"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "agentSchemaNumber"
    },
    {
      "kind": "FragmentSpread",
      "name": "creator_AtlassianConversationAssistantAgent_AgentCreatorDataComponent"
    },
    {
      "kind": "FragmentSpread",
      "name": "agentVerified_AtlaskitRovoAgentComponents"
    },
    {
      "kind": "FragmentSpread",
      "name": "agentVerificationDropdownItem_AtlaskitRovoAgentComponents_agentRef"
    }
  ],
  "type": "AgentStudioAssistant"
};

(node as any).hash = "5025c0bdbfa530ea89da761610e6cab8";

export default node;
